module.exports = __webpack_public_path__ + "static/media/proj15_img7.ea9ee8f4.jpg";